import { Languages } from '../../domain/Language';
import type { Language } from '../../domain/Language';

export const LanguageMap = {
  toInstance: (language: any): Language => {
    if (language in Languages) return language;
    throw new Error(`Language ${language} is not in the list of languages.`);
  },
};
